module.exports = __webpack_public_path__ + "img/pic26.bfbc021f.jpg";